// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"tW","skip_info":"uW","skipped":"vW","modify_order":"wW","cancel_subscription_btn":"xW","byb":"yW","modify_order_outer":"zW","byb_edit_btn":"AW","modify_order_item":"BW","cancel_copy_wrapper":"CW","cancelled_copy":"EW"};
    if(module.hot) {
      // 1715632478913
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  